import React from "react";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="thankyou-wrapper">
      <div className="thankyou-card">
        <div className="thankyou-icon">
          ✓
          {/* <i className="fa fa-handshake"/> */}
        </div>

        <h1 className="thankyou-title">Thank You!</h1>

        <p className="thankyou-message">
          Thank you for visiting the Jointer Verification Portal.
          We appreciate your time. If you would like to search or verify
          another jointer, you can continue below.
        </p>

        <div className="thankyou-actions">
          <Button
            color="deep-blue"
            className="thankyou-btn"
            onClick={() => navigate("/skills-verification")}
          >
            Search Another Jointer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;